import { gql } from "@apollo/client";
export const GET_stations = gql`query GET_stations($networkInput: NetworkInput, $indoorInput: IndoorInput, $getGeometriesInput: GetGeometriesInput) {
    Network(NetworkInput: $networkInput) {
        properties {
            longName
            transportationUnitId
            lines {
                line
                direction
            }
            neighbours {
                direction
                shortName
                longname
                lines {
                    line
                    direction
                }
                geometry {
                    coordinates
                    type
                }
                transportationUnitId
                traveltime
                type
                anchorConnection {
                    routenode_id
                    cost
                    value
                }
            }
        }
        geometry {
            coordinates
            type
        }
    }
    Indoor(IndoorInput: $indoorInput) {
        geometry {
            coordinates
            type
        }
        properties {
            anchor {
                name
                type
            }
            floor {
                name
                vertorder
            }
            neighbours {
                aim {
                    id
                }
                geometry {
                    coordinates
                    type
                }
                image {
                    link
                    name {
                        text
                    }
                }
                toll
                floor
                traveldistance
                routeEdge
            }
            poi {
                name {
                    text
                }
            }
            qrcode {
                code
            }
            routeNode
            panorama {
                link
            }
            accessibility
            spaceconnection {
                indoorInstallationType
                indoorInstallationName {
                    language
                    text
                }
                subType
                location
                state
                type
                levels
            }
            transportationUnit {
                id
                longName
            }
            image {
                link
            }
            interiorSpaceType
            interiorSpaceId
        }
        type
    }
    GetGeometries(GetGeometriesInput: $getGeometriesInput) {
        interiorSpace {
            floor_name
            geometry {
                coordinates
                type
            }
            transportationunit_id
        }
    }
}`

export const GET_stations_select = gql`query GET_stations($networkInput: NetworkInput) {
    Network(NetworkInput: $networkInput) {
        properties {
            longName
            transportationUnitId
        }
        geometry {
            coordinates
            type
        }
    }
}`